<template>
  <!---------- CAROUSEL SECTION ---------->
  <div>
    <Carousel />
  </div>
  <!---------- BANNER SECTION ---------->

  <div class="banner">

    <div class="banner-intro">
      <h1 class="banner-text">Tech for filipino youth organization</h1>
      <p class="p1">A non-profit organisation with the mission of raising awareness of the imbalance of education
        opportunities among the Filipino youth, and bridging the gap by supporting the less fortunate with the tools they
        need to aid them in the new
        mode of distance learning.</p>
    </div>
    <div class="rows">
      <img src="@/assets/firstbanner-img/Frame7.png">
      <img src="@/assets/firstbanner-img/Frame6.png">
      <img src="@/assets/firstbanner-img/Frame8.png">
    </div>
  </div>


  <!---------- ANNOUNCEMENTS SECTION ---------->

  <div class="announce-body">
    <section class="announcements">
      <div class="text-section">
        <h2 class="tl-text">TIMELINE</h2>
        <p class="p3">Catch up with the latest news about our organization to find out more about us, what have we been
          doing and our previous activities!</p>

        <div class="timeButton">
          <router-link :to="`/timeline`" class="announceB">View The TFYO Timeline</router-link>
        </div>

      </div>
      <div class="content-section">
        <div class="content-box">
          <div class="div1">
            <img src="@/assets/announcements-img/news1.png" class="imgz" />
            <div class="div2">
              <p class="p6"> TFYO BrigadaTechSkwela: Nueva Ecija </p>
              <p class="p7"> In partnership with @kathalifestylestore, our team visited one of the public elementary
                schools far north to provide 20 tablets to chosen students.</p>
            </div>
          </div>

          <div class="div1">
            <img src="@/assets/announcements-img/news2.png" class="imgz" />
            <div class="div2">
              <p class="p6"> Transparency Report: MusiKabataan </p>
              <p class="p7"> Transparency Report from our first ever live benefit concert held at Calor Membership Lounge,
                which garnered Php 377,750 donations and Php 36,750 ticket sales. </p>
            </div>
          </div>

          <div class="div1">
            <img src="@/assets/announcements-img/news3.png" class="imgz" />
            <div class="div2">
              <p class="p6"> TFYO BrigadaTechSkwela: Pampanga </p>
              <p class="p7">
                San Isidro National High School and San Roque Elementary School are two of the public schools we helped as
                part of our Brigada Techskwela Project for Nueva Ecija.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>



  <!-- NOTE: Set position: relative for overlay position -->
  <!---------- EVENTS SECTION ---------->

  <div class="eventBox" v-if="events.length != 0">
    <h3 class="event-text"> JOIN OUR UPCOMING EVENTS</h3>

    <!-- GET -->
    <div class="rowz" style="position: relative;">
      <v-overlay v-model="loadingUpcoming" contained class="align-center justify-center" scrim="transparent" persistent>
        <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <HomeEventCard :event="event" v-for="event in events" :key="event.id" />
    </div>
  </div>

  <!---------- VOLUNTEER SECTION ---------->

  <div class="container" id="volunteerBox" style="position: relative;" v-if="volunteerEvents.length != 0">
    <v-overlay v-model="loadingOpportunities" contained class="align-center justify-center" scrim="transparent"
      persistent>
      <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h3 class="volunteer-text"> VOLUNTEER OPPORTUNITIES</h3>

    <div class="rowz" id="perdev-card">
      <VolunteerEventCard :event="event" v-for="event in volunteerEvents" :key="event.id" />
    </div>

  </div>
</template>

<script>
// Dependencies
import { db } from "@/firebase"
import { onBeforeMount, onMounted, ref, onUnmounted } from 'vue'
import { collection, onSnapshot, query, orderBy, where } from "firebase/firestore";
import { useStore } from 'vuex';
import HomeEventCard from '@/components/HomeEventCard.vue';
import VolunteerEventCard from '@/components/VolunteerEventCard.vue';
import Carousel from '@/components/Carousel.vue';

export default {
  components: {
    HomeEventCard,
    VolunteerEventCard,
    Carousel,
  },
  setup() {
    const events = ref([]);
    const volunteerEvents = ref([]);
    const loadingUpcoming = ref(true);
    const loadingOpportunities = ref(true);

    let unsubscribe;

    onBeforeMount(async () => {
      await useStore().dispatch('events/fetchEmptyImage')
    })

    onMounted(() => {
      // Get available events for upcoming events
      const eventsCollection = collection(db, 'Events');
      // For upcoming events that has a host
      let q = query(eventsCollection, where("IsOpen", "==", true), where("IsArchived", "==", false), orderBy("StartTime", "desc"));

      unsubscribe = onSnapshot(q, async (snapshot) => {
        events.value = snapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() }
        })
        loadingUpcoming.value = false;
      })

      // Get available events for volunteers
      q = query(eventsCollection, where("IsOpen", "==", false), where("IsArchived", "==", false), orderBy("StartTime", "desc"));
      unsubscribe = onSnapshot(q, (snapshot) => {
        volunteerEvents.value = snapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() }
        })
        loadingOpportunities.value = false;
      });
    });

    onUnmounted(() => {
      unsubscribe();
    })
    return { events, volunteerEvents, loadingUpcoming, loadingOpportunities, Carousel }
  }
}


</script>

<style scoped src="@/assets/css/globalStyle.css"></style>
<style scoped src="@/assets/css/home.css"></style>